// eslint-disable-next-line import/no-cycle
import { useGlobalStore } from '@/stores/globalStore';
import http from './http';
import useErrorHandling from './useErrorHandling';

export default () => {
  const { handleServerErrors } = useErrorHandling();

  const resetFetchingState = () => {
    const globalStore = useGlobalStore();
    globalStore.fetchingToken = false;
    globalStore.pendingTokenPromise = null;
  };

  const getToken = async () => http
      .get('/token')
      .then((response) => {
        const token = response.data.bearer_token;
        const globalStore = useGlobalStore();
        sessionStorage.setItem('token', token);
        globalStore.token = token;

        return token;
      })
      .catch((err) => {
        handleServerErrors(err);
        throw err;
      });

  const checkAndSyncExistingToken = () => {
    const globalStore = useGlobalStore();
    const sessionToken = sessionStorage.getItem('token');
    const storeToken = globalStore.token;
    const existingToken = sessionToken || storeToken;

    if (!sessionToken && storeToken) {
      sessionStorage.setItem('token', storeToken);
    }

    if (!storeToken && sessionToken) {
      globalStore.token = sessionToken;
    }

    return existingToken;
  };

  const handlePendingTokenFetch = async () => {
    const globalStore = useGlobalStore();
    if (!globalStore.pendingTokenPromise) {
      return null;
    }

    try {
      return await globalStore.pendingTokenPromise;
    } catch (error) {
      resetFetchingState();
      throw error;
    }
  };

  const performTokenFetch = async () => {
    const globalStore = useGlobalStore();
    globalStore.fetchingToken = true;

    globalStore.pendingTokenPromise = (async () => {
      try {
        await http.get('/csrf-cookie').catch((err) => {
          handleServerErrors(err);
          throw err;
        });

        const authToken = await getToken();

        return authToken;
      } finally {
        resetFetchingState();
      }
    })();

    return globalStore.pendingTokenPromise;
  };

  const fetchAuthToken = async () => {
    const globalStore = useGlobalStore();
    const existingToken = checkAndSyncExistingToken();

    if (existingToken) {
      return existingToken;
    }

    if (globalStore.fetchingToken) {
      return handlePendingTokenFetch();
    }

    return performTokenFetch();
  };

  const clearAuthToken = () => {
    sessionStorage.removeItem('token');
    const globalStore = useGlobalStore();
    globalStore.token = null;
    resetFetchingState();
  };

  const setAuthToken = (token) => {
    sessionStorage.setItem('token', token);
    const globalStore = useGlobalStore();
    globalStore.token = token;
  };

  return {
    fetchAuthToken,
    clearAuthToken,
    setAuthToken,
  };
};
